export const Logo = () => {
    return <p className={'logo'}>StreamHelper</p>
}